import * as React from "react";
import { Dispatch } from "react";
import styled from "@mui/material/styles/styled";

import { QualifiedFeature } from "fe-common/graphql";
import { DataInput } from "../../dataInputTypes";
import Button from "@mui/material/Button";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { Theme } from "@mui/material";

//region [[ Styles ]]

const YesNoButtonComponentView = styled("div")(({ theme }) => ({
  display: "flex",
}));

export const YesNoButton = styled(Button)(
  ({ theme, clicked }: { theme?: Theme; clicked: string }) => ({
    color: clicked === "true" ? "white" : KahunColorMap.PrimaryDim,
    backgroundColor:
      clicked === "true" ? KahunColorMap.PrimaryDim : "transparent",
    border: "1px solid " + KahunColorMap.PrimaryDim,

    "&:focus, &:hover, &:active": {
      color: clicked === "true" ? "white" : KahunColorMap.PrimaryDim,
      backgroundColor:
        clicked === "true" ? KahunColorMap.PrimaryDim : "transparent",
      border: "1px solid " + KahunColorMap.PrimaryDim,
    },

    [theme.breakpoints.up(MobileView)]: {
      minWidth: "74px",
      fontSize: "14px",
      lineHeight: "16px",
    },
    [theme.breakpoints.down(MobileView)]: {
      minWidth: "52px",
      fontSize: "14px",
      lineHeight: "14px",
    },

    height: "30px",
    letterSpacing: "0",
    textTransform: "capitalize",
    flex: 1,
    borderRadius: "34px",
  }),
);

export const YesNoButtonFrame = styled("div")(({ theme }) => ({
  padding: "3px",
  display: "flex",
  alignItems: "center",

  [theme.breakpoints.up(MobileView)]: {
    height: "34px",
  },
  [theme.breakpoints.down(MobileView)]: {
    height: "32px",
  },

  borderRadius: "6.25px",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface YesNoButtonComponentProps {
  qf: QualifiedFeature;
  response?: DataInput;
  onChange: Dispatch<DataInput>;
  disabled: boolean;
  labLabels?: boolean;
  allowDeselect?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const YesNoButtonComponent = ({
  ...props
}: YesNoButtonComponentProps) => {
  const onYes = () => {
    if (
      props.allowDeselect === true &&
      props.response &&
      props.response.negate === false
    ) {
      props.onChange(null);
    } else {
      props.onChange({ negate: false });
    }
  };

  const onNo = () => {
    if (
      props.allowDeselect === true &&
      props.response &&
      props.response.negate === true
    ) {
      props.onChange(null);
    } else {
      props.onChange({ negate: true });
    }
  };

  return (
    <YesNoButtonComponentView>
      <YesNoButtonFrame
        style={{
          paddingLeft: !props.response ? "0px" : "1.5px",
          borderBottomLeftRadius: !props.response ? "6.25px" : "0px",
          borderTopLeftRadius: !props.response ? "6.25px" : "0px",
        }}
      >
        <YesNoButton
          disableElevation
          clicked={
            props.response && props.response.negate === false ? "true" : "false"
          }
          onClick={onYes}
        >
          {props.labLabels === true ? "Positive" : "Yes"}
        </YesNoButton>
      </YesNoButtonFrame>
      <YesNoButtonFrame
        style={{
          marginRight: !props.response ? "3px" : "0px",
          paddingRight: !props.response ? "0px" : "1.5px",
          borderBottomRightRadius: !props.response ? "6.25px" : "0px",
          borderTopRightRadius: !props.response ? "6.25px" : "0px",
        }}
      >
        <YesNoButton
          disableElevation
          clicked={
            props.response && props.response.negate === true ? "true" : "false"
          }
          onClick={onNo}
        >
          {props.labLabels === true ? "Negative" : "No"}
        </YesNoButton>
      </YesNoButtonFrame>
    </YesNoButtonComponentView>
  );
};
